import { Component, OnInit } from '@angular/core';
import { AbstractControl, FormBuilder, FormGroup, ValidationErrors, ValidatorFn, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { UserLayoutService } from '../../layouts/user-layout/user-layout.service';
import { CommonService } from '../../shared/common.service';
import { OrganizationEnumModel } from '../../shared/constant/organization.model';

@Component({
  selector: 'app-footer',
  templateUrl: './footer.component.html',
  styleUrls: ['./footer.component.css']
})
export class FooterComponent implements OnInit {
  test: Date = new Date();
  subscriberDetailsForm: FormGroup;
  emailSubmitted: boolean = false;

  indianWhastAppNo: string = ""
  globalWhastAppNo: string = ""
  constructor(
    public router: Router,
    public userLayoutService: UserLayoutService,
    private fb: FormBuilder,
    public commonService: CommonService,
  ) { }

  ngOnInit() {
    this.defaultSubscriberDetailsForm();
    const organizationAttributes = JSON.parse(localStorage.getItem('organizationAttributes'));
    this.globalWhastAppNo = organizationAttributes.find((attr: any) => attr.attributeName === OrganizationEnumModel.globalWhastAppNo && attr.value == true)?.customValue
    this.indianWhastAppNo = organizationAttributes.find((attr: any) => attr.attributeName === OrganizationEnumModel.indiaWhastAppNo && attr.value == true)?.customValue
  }

  defaultSubscriberDetailsForm() {
    this.subscriberDetailsForm = this.fb.group({
      email: ['', [Validators.required, this.customEmailValidator()]],
    });
    this.emailSubmitted = false;
  }

  customEmailValidator(): ValidatorFn {
    return (control: AbstractControl): ValidationErrors | null => {
      const emailPattern = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
      const isValidEmail = emailPattern.test(control.value);
      return isValidEmail ? null : { 'invalidEmail': true };
    };
  }

  onSubscribe() {
    this.emailSubmitted = true;

    if (this.subscriberDetailsForm.get('email').invalid && this.emailSubmitted) {
      this.commonService.notifier.notify('error', "Enter valid email.");
      return;
    }

    let emailObj = {
      email: this.subscriberDetailsForm.get('email')?.value || null,
    }

    this.userLayoutService.subscribeNew(emailObj).subscribe(
      (response: any) => {
        if (response.code === 1) {
          this.defaultSubscriberDetailsForm();
          this.commonService.notifier.notify('success', response.message);
        } else {
          this.commonService.notifier.notify('error', response.message);
        }
      },
      (error) => {
        this.commonService.notifier.notify('error', "An Error Occured While Subscribing.");
      }
    );
  }

  formatPhone(phone: string): string {
    if (!phone) return '';

    // Remove non-digits (in case any exist)
    phone = phone.replace(/\D/g, '');

    // Format Indian number: 91XXXXXXXXXX -> +91 XXXXX YYYYY
    if (phone.startsWith('91') && phone.length === 12) {
      return `+91 ${phone.slice(2, 7)} ${phone.slice(7)}`;
    }

    // Format US number: 1XXXXXXXXXX -> +1 (XXX) XXX-XXXX
    if (phone.startsWith('1') && phone.length === 11) {
      return `+1 (${phone.slice(1, 4)}) ${phone.slice(4, 7)}-${phone.slice(7)}`;
    }

    // Generic fallback: just add + and spaces every few digits
    return '+' + phone;
  }

}
